export default "__VITE_ASSET__DmRhfMeU__"